import React from "react";

// Components imports
import InputField from "../../../common/InputField";

// Scss imports
import css from "./LegalEntityBasicData.module.scss";
interface LegalEntityBasicDataProps {
  businessName: string;
  identificationNumber: string;
  taxId: string;
  handleChange: Function;
  errorText: string;
  businessNameError: string;
  identificationNumberError: string;
  taxIdError: string;
}

const LegalEntityBasicData: React.FC<LegalEntityBasicDataProps> = ({
  businessName,
  identificationNumber,
  taxId,
  handleChange,
  errorText,
  businessNameError,
  identificationNumberError,
  taxIdError,
}) => {
  return (
    <div className={css.container}>
      <div className={css.inputFieldWrapper}>
        <InputField
          label="Пословно име"
          name="businessName"
          id="businessName"
          type="text"
          placeholder="Пузле компанија"
          value={businessName}
          handleChange={handleChange}
          handleOnFocus={(e: any) => (e.target.placeholder = "")}
          handleOnBlur={(e: any) => (e.target.placeholder = "Пузле компанија")}
          errorText={businessNameError}
        />
      </div>

      {/*<div className={css.inputFieldWrapper}>
        <InputField
          label="Матични број фирме"
          name="identificationNumber"
          id="identificationNumber"
          type="text"
          placeholder="56396444"
          value={identificationNumber}
          handleChange={handleChange}
          handleOnFocus={(e: any) => (e.target.placeholder = "")}
          handleOnBlur={(e: any) => (e.target.placeholder = "56396444")}
          errorText={identificationNumberError}
        />
  </div>*/}
      <div className={css.inputFieldWrapper}>
        <InputField
          label="ПИБ"
          name="taxId"
          id="taxId"
          type="text"
          placeholder="544344333"
          value={taxId}
          handleChange={handleChange}
          handleOnFocus={(e: any) => (e.target.placeholder = "")}
          handleOnBlur={(e: any) => (e.target.placeholder = "544344333")}
          errorText={taxIdError}
        />
      </div>
    </div>
  );
};

export default LegalEntityBasicData;
